module.exports = __webpack_public_path__ + "img/Carousel_Header4.374c6c15.png";